import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewService } from './preview.service';
import { PreviewComponent } from './preview.component';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from '../dropdown/dropdown.module';

@NgModule({
  declarations: [PreviewComponent],
  exports: [PreviewComponent],
  imports: [CommonModule, DropdownModule, TranslateModule],
  providers: [PreviewService]
})
export class PreviewModule {}



// WEBPACK FOOTER //
// ./src/app/modules/preview/preview.module.ts